import { render, staticRenderFns } from "./ListITradeIn.vue?vue&type=template&id=15d36750&scoped=true"
import script from "./ListITradeIn.vue?vue&type=script&lang=js"
export * from "./ListITradeIn.vue?vue&type=script&lang=js"
import style0 from "./ListITradeIn.vue?vue&type=style&index=0&id=15d36750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d36750",
  null
  
)

export default component.exports